module.exports = __webpack_public_path__ + "static/media/ShareIcon.bd9c4ea0.svg";